import type { InteractionsConfig } from '@wix/thunderbolt-becky-types'

export const EMPTY_INTERACTIONS_CONFIG = { interactions: [], effects: {} } as InteractionsConfig
